import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Star } from 'assets/svg/icon-star.svg'

function IconStar(props: IconProps): JSX.Element {
  const title = 'icon-star'
  const {
    className,
    id = title,
    name = title,
    variants = 'star',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Star {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconStar
